import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dff8c71a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contact",
  style: {"background-color":"#fff"}
}
const _hoisted_2 = { class: "content-wrap" }
const _hoisted_3 = { class: "contact-us" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "联系我们", -1))
const _hoisted_5 = { class: "card contact-information" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "联系方式", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "联系人", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "电子邮件", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "微信号", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "联系地址", -1))
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "consult" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pc-wrap" }, "留言咨询", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "phone-wrap" }, "留言咨询", -1))
const _hoisted_17 = { class: "consult-form" }
const _hoisted_18 = { class: "form-wrap card pc-wrap" }
const _hoisted_19 = { class: "phone-wrap" }
const _hoisted_20 = { class: "top-wrap" }
const _hoisted_21 = { class: "btn-wrap" }
const _hoisted_22 = { class: "company-info card" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "pc-wrap" }, "公司信息", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "phone-wrap" }, "公司信息", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "公司名称", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "公司地址", -1))

import {computed, defineAsyncComponent, ref} from "vue";
import {singlePageApi, submitMessageApi} from '@/api/common'
import {ElMessage} from "element-plus";
import {validatePhone} from "@/utils/validate";

// 引入组件
interface ruleForm {
  name: string,
  content: string,
  tel: string | number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

_useCssVars(_ctx => ({
  "37ec2162": (companyInfoBg1),
  "37ec2160": (companyInfoBg2)
}))

const GadeMap = defineAsyncComponent(() => import('./components/GadeMap.vue'));

// 表单信息
const contact = ref(null);
const contactPhone = ref(null);

const form = ref<ruleForm>({
  name: '',
  content: '',
  tel: ''
});

const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
  tel: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { validator: validatePhone, trigger: 'blur' },
  ]
};

const submitForm = async (formEl: any) => {
  if (!formEl) return
  await formEl.validate(async (valid: any, fields: any) => {
    if (valid) {
      await submitMessageApi(form.value);
      ElMessage.success('留言成功');
      formEl.resetFields();
    } else {
      console.log('error submit!', fields)
    }
  })
};

/**
 * 联系我们内容
 */
const mainContent = ref<any>({
  address: '',
  pic: '',
  company_name: ''
});

// 获取单页内容
const getSinglePage = async () => {
  mainContent.value = await singlePageApi({id: 2});
}

/**
 * 获取公司地址
 */
const companyAddress = computed(() => {
  if (mainContent.value.address) {
    return mainContent.value.address.split('：')[1] || mainContent.value.address.split(':')[1];
  } else {
    return ''
  }
});

/**
 * 获取公司名称
 */
const companyName = computed(()=> {
  if (mainContent.value.company_name) {
    return mainContent.value.company_name.split('：')[1] || mainContent.value.company_name.split(':')[1];
  } else {
    return ''
  }
})

getSinglePage()

const companyInfoBg1 = `url(${require('@/assets/contact/company-info.png')})`;
const companyInfoBg2 = `url(${require('@/assets/contact/company-info2.png')})`;


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "banner pc-wrap",
      style: _normalizeStyle(`background: url(${require('@/assets/contact/banner.png')}) center;background-size: cover;`)
    }, null, 4),
    _createElementVNode("div", {
      class: "banner phone-wrap",
      style: _normalizeStyle(`background: url(${require('@/assets/contact/banner2.png')}) center;background-size: cover;`)
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(mainContent.value?.keywords || '无'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(mainContent.value.description || '无'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, [
                    (mainContent.value.pic)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: mainContent.value.pic,
                          alt: ""
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(mainContent.value?.address), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (companyAddress.value)
              ? (_openBlock(), _createBlock(_unref(GadeMap), {
                  key: 0,
                  address: companyAddress.value
                }, null, 8, ["address"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_form, {
              model: form.value,
              class: "form",
              rules: rules,
              ref_key: "contact",
              ref: contact,
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  class: "input-wrap",
                  prop: "name",
                  label: "姓名"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      link: "",
                      placeholder: "请输入您的姓名",
                      modelValue: form.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "input-wrap",
                  prop: "content",
                  label: "留言"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      link: "",
                      placeholder: "请输入留言内容",
                      modelValue: form.value.content,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.content) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "input-wrap",
                  prop: "tel",
                  label: "联系方式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      link: "",
                      placeholder: "请输入您的电话",
                      modelValue: form.value.tel,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.tel) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { class: "input-wrap btn-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(contact.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("马上提交")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_form, {
              model: form.value,
              class: "form",
              rules: rules,
              ref_key: "contactPhone",
              ref: contactPhone,
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_form_item, {
                      class: "input-wrap",
                      prop: "name",
                      label: "姓名"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          link: "",
                          placeholder: "请输入您的姓名",
                          modelValue: form.value.name,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "input-wrap",
                      prop: "tel",
                      label: "联系方式"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          link: "",
                          placeholder: "请输入您的电话",
                          modelValue: form.value.tel,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.tel) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_form_item, {
                      class: "input-wrap leave-message",
                      prop: "content",
                      label: "留言"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          link: "",
                          placeholder: "请输入留言内容",
                          modelValue: form.value.content,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.content) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    color: "#BC0507",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(contactPhone.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("马上提交")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", null, _toDisplayString(companyName.value), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _createElementVNode("td", null, _toDisplayString(companyAddress.value), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})